import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TranscribeAudioMutationVariables = Types.Exact<{
  audio: Types.Scalars['Upload']['input'];
  language?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type TranscribeAudioMutation = { __typename?: 'Mutation', transcribeAudio: { __typename?: 'TranscribeAudioMutationResult', success: boolean, text?: string | null, error?: { __typename?: 'Error', code: string } | null } };


export const TranscribeAudioDocument = gql`
    mutation TranscribeAudio($audio: Upload!, $language: String) {
  transcribeAudio(audio: $audio, language: $language) {
    success
    text
    error {
      code
    }
  }
}
    `;
export type TranscribeAudioMutationFn = Apollo.MutationFunction<TranscribeAudioMutation, TranscribeAudioMutationVariables>;

/**
 * __useTranscribeAudioMutation__
 *
 * To run a mutation, you first call `useTranscribeAudioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTranscribeAudioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transcribeAudioMutation, { data, loading, error }] = useTranscribeAudioMutation({
 *   variables: {
 *      audio: // value for 'audio'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useTranscribeAudioMutation(baseOptions?: Apollo.MutationHookOptions<TranscribeAudioMutation, TranscribeAudioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TranscribeAudioMutation, TranscribeAudioMutationVariables>(TranscribeAudioDocument, options);
      }
export type TranscribeAudioMutationHookResult = ReturnType<typeof useTranscribeAudioMutation>;
export type TranscribeAudioMutationResult = Apollo.MutationResult<TranscribeAudioMutation>;
export type TranscribeAudioMutationOptions = Apollo.BaseMutationOptions<TranscribeAudioMutation, TranscribeAudioMutationVariables>;